import React from "react";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../constants";

export default function Testimonials() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 bg-page"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 sm:mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="label-eyebrow mb-4">Lo dicen ellas</div>
            <h2
              data-testid="testimonials-title"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
            >
              Historias reales,
              <br />
              prendas que <span className="italic text-vino">acompañan</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-center gap-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-vino text-vino" />
              ))}
            </div>
            <div>
              <div className="font-heading text-2xl text-ink leading-none">
                4.9 / 5
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-ink-soft mt-1">
                +800 clientes vestidos
              </div>
            </div>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid md:grid-cols-12 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, idx) => {
            // Asymmetrical layout
            const layouts = [
              "md:col-span-7 md:row-span-2",
              "md:col-span-5",
              "md:col-span-5",
              "md:col-span-7",
            ];
            const isHighlight = idx === 0;
            return (
              <article
                key={t.name}
                data-testid={`testimonial-card-${idx}`}
                className={`${layouts[idx]} rounded-[2rem] overflow-hidden border border-line ${
                  isHighlight ? "bg-vino text-page" : "bg-sand text-ink"
                } p-7 sm:p-9 flex flex-col justify-between min-h-[260px] relative`}
              >
                <Quote
                  size={36}
                  className={`mb-5 ${isHighlight ? "text-cream/40" : "text-vino/30"}`}
                />
                <p
                  className={`font-heading text-xl sm:text-2xl lg:text-[28px] leading-snug ${
                    isHighlight ? "text-page" : "text-ink"
                  }`}
                >
                  “{t.quote}”
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover border border-line"
                  />
                  <div>
                    <div
                      className={`font-medium text-sm ${
                        isHighlight ? "text-page" : "text-ink"
                      }`}
                    >
                      {t.name}
                    </div>
                    <div
                      className={`text-xs ${
                        isHighlight ? "text-cream" : "text-ink-soft"
                      }`}
                    >
                      {t.role}
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
